import { SCORE_LIMIT } from "./types";
import type { TeamId, Wardstone, World } from "./types";
import { dist } from "./vec";

const CAPTURE_SECS = 2.4;

export function occupants(world: World, stone: Wardstone): [number, number] {
  let a = 0;
  let b = 0;
  for (const u of world.units) {
    if (u.dead) continue;
    if (dist(u.pos, stone.pos) <= stone.radius + u.radius * 0.4) {
      if (u.team === 0) a += 1;
      else b += 1;
    }
  }
  return [a, b];
}

export function tickStones(world: World, dt: number): void {
  for (const stone of world.stones) {
    const [c0, c1] = occupants(world, stone);
    let side: TeamId | null = null;
    if (c0 > 0 && c1 === 0) side = 0;
    else if (c1 > 0 && c0 === 0) side = 1;

    if (side === null) {
      stone.capturing = c0 > 0 && c1 > 0 ? stone.capturing : null;
      if (c0 === 0 && c1 === 0) {
        stone.progress = Math.max(0, stone.progress - dt * 0.25);
      }
      continue;
    }

    if (stone.owner === side) {
      stone.progress = 0;
      stone.capturing = null;
      continue;
    }

    if (stone.capturing !== side) {
      stone.capturing = side;
      stone.progress = Math.min(stone.progress, 0.15);
    }
    const count = side === 0 ? c0 : c1;
    stone.progress += (dt / CAPTURE_SECS) * (1 + (count - 1) * 0.35);
    if (stone.progress >= 1) {
      stone.owner = side;
      stone.progress = 0;
      stone.capturing = null;
    }
  }
}

export function tickScore(world: World, dt: number): void {
  if (world.over) return;
  const scoring = world.suddenDeath
    ? world.stones.filter((s) => s.name === "Heart")
    : world.stones;
  let add0 = 0;
  let add1 = 0;
  const rate = world.suddenDeath ? 1.6 : 0.72;
  for (const s of scoring) {
    if (s.owner === 0) add0 += dt * rate;
    if (s.owner === 1) add1 += dt * rate;
  }
  world.scores[0] += add0;
  world.scores[1] += add1;
}

export function checkWinner(world: World): void {
  if (world.over) return;
  const s0 = world.scores[0];
  const s1 = world.scores[1];
  if (s0 >= SCORE_LIMIT || s1 >= SCORE_LIMIT) {
    world.over = true;
    world.winner = s0 === s1 ? null : s0 > s1 ? 0 : 1;
    world.endedReason = "score";
    return;
  }
  if (world.time >= world.duration) {
    const f0 = Math.floor(s0);
    const f1 = Math.floor(s1);
    if (f0 !== f1) {
      world.over = true;
      world.winner = f0 > f1 ? 0 : 1;
      world.endedReason = "clock";
      return;
    }
    world.suddenDeath = true;
  }
  if (world.suddenDeath) {
    const f0 = Math.floor(s0);
    const f1 = Math.floor(s1);
    if (f0 !== f1) {
      world.over = true;
      world.winner = f0 > f1 ? 0 : 1;
      world.endedReason = "sudden";
    }
  }
}
